import { useGetAgencyButtons } from '../utils/useGetAgencyButtons';
import useManageAgencyState from '../utils/useManageAgencyState';
import AgencyBasicInfo from './AgencyBasicInfo';
import TwoFactorToggle from './TwoFactorToggle';
import { useSelector } from 'react-redux';
import TimeSelector from './TimeSelector';
import AgencyUserCount from './AgencyUserCount';
import {
	PageLayout,
	AddressForm,
	SectionHeader,
	FormSectionHeader,
	Loader,
} from 'components';

export default function ManageAgency() {
	const agencyInfo = useSelector((state) => state.user.agency);
	const sessionTTL = useSelector((state) => state.user.sessionTTL);
	const { name, office, agency } = useManageAgencyState();

	const getBody = () => {
		const reqBody = {
			name: name?.value,
			id: agency?.id,
			office: office?.value,
			required: true,
			enforceSessionTTLInSeconds: sessionTTL,
		};
		return {
			reqBody,
		};
	};

	const buttonArray = useGetAgencyButtons(getBody);

	return (
		<PageLayout title={'Edit Agency'} buttonArray={buttonArray} align='left'>
			{!agencyInfo.id ? (
				<Loader />
			) : (
				<>
					<AgencyBasicInfo inputs={[name, office]} />
					<SectionHeader>ADDRESS</SectionHeader>
					<AddressForm key={agency?.id} required={true} />
					<FormSectionHeader hideTop>Management Options</FormSectionHeader>
					<TwoFactorToggle agenyInfo={agencyInfo} />
					<TimeSelector />
					<AgencyUserCount />
				</>
			)}
		</PageLayout>
	);
}
